import { gql } from '@apollo/client';

export const ADD_EXTERNAL_CALENDARS = gql`
  mutation AddExternalCalendars($calendar: CalendarConnectionInput!, $entries: [CalendarEntryInput!]!) {
    addExternalCalendars(input: $calendar, entries: $entries) {
      success
    }
  }
`;